<template>
  <div class="big-data">
    <div class="banner" v-lazy:background-image="{ src: trueAiOrBigData,
        loading: aiOrBigData}">
      <!-- <div class="divContsBg"></div> -->
      <!-- <div class="conts">
        <slot name="navList"></slot>
        <div class="texts">
          <h1 v-if="backGroundCom.onIndex == 2"><span>{{backGroundCom.title1}}</span><span>&nbsp;&nbsp;—&nbsp;&nbsp;</span><span>{{backGroundCom.title}}</span></h1>
          <h1 v-else>{{backGroundCom.title}}</h1>
          <p style="font-size: 24px;">{{backGroundCom.enTitle}}</p>
          <ul class="imglist" style="width: 50%;">
            <li v-for="(item, index) in backGroundCom.projectList" :key="item.id">
              <img v-if="backGroundCom.onIndex === 4" style="width: 69px;vertical-align: middle;display: inline-block;" :src="imgList4[index]" alt="" />
              <img v-if="backGroundCom.onIndex === 2" style="width: 69px;vertical-align: middle;display: inline-block;" :src="imgList2[index]" alt="" />
              <span style="display: block;text-align: center;margin-top: 10px;color: #fff;">{{item.typeList}}</span>
              <span style="color: #fff;display: inline-block;margin-top: 4px;">{{item.realList}}</span>
            </li>
          </ul>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>

export default {
  props: {
    backGroundCom: {
      readonly: true,
      require: true,
      default: () => {}
    }
  },
  data () {
    return {
      menuDatas: [],
      imgList4: [
        require("../bigDataImg/icon_dachangji.png"),
        require("../bigDataImg/icon_duohangye.png"),
        require("../bigDataImg/icon_jiyuqiye.png"),
        require("../bigDataImg/icon_qiyezhenshi.png")
      ],
      imgList2: [
        require("../bigDataImg/ai/web2x_icon_yixianhuoren.png"),
        require("../bigDataImg/ai/web2x_icon_duohangye.png"),
        require("../bigDataImg/ai/web2x_icon_hezuo.png"),
        require("../bigDataImg/ai/web2x_icon_jishuzhuanjia.png")
      ]
    }
  },
  computed: {
    aiOrBigData () {
      if (this.backGroundCom.onIndex === 2) {
        return require('../bigDataImg/rengongzhineng.jpg')
      } else {
        return require('../bigDataImg/dashuju.jpg')
      }
    },
    trueAiOrBigData () {
      if (this.backGroundCom.onIndex === 2) {
        return require('../bigDataImg/banner.png')
      } else {
        return require('../bigDataImg/banner.png')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .big-data {
    h1 {
      font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Regular";
      height: 69px;
      font-size: 50px;
      font-weight: 900;
      color: white;
      line-height: 69px;
      margin-top: 80px;
    }
    p {
      font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Semibold";
      height: 80px;
      font-size: 24px;
      font-weight: 300;
      opacity: 0.8;
      color: white;
      line-height: 40px;
      margin-top: 10px;
    }
  }
  .big-data {
    padding: 0;
    margin: 0;
    background: white;
    min-width: 1200px;
    .banner {
      width: 100%;
      height: 510px;
      overflow: hidden;
      position: relative;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      .imgs {
        position: absolute;
        width: 108px;
        height: 108px;
        left: 50%;
        top: 50%;
        margin-left: -54px;
        margin-top: -50px;
        display: none;
        img {
          width: 69px;
        }
      }
      .divContsBg {
        // background-color: black;
        position: absolute;
        width: 100%;
        height: 81px;
        top: 0;
        // opacity: 0.11;
      }
      .conts {
        width: 1200px;
        margin: 0 auto;
        position: relative;
        ul {
          display: flex;
          justify-content: space-around;
          // margin-top: 24px;
          .title-nav {
            height: 32px;
            border-radius: 20px;
            background-color: white;
            cursor: pointer;
            &:hover {
              color: #1286FF;
            }
            a {
              border-radius: 20px;
              line-height: 32px;
              width: 100%;
              padding: 7px 35px;
              box-sizing: border-box;
            }
          }
          .active {
            background: #1286FF;
            color: #f9f9f9 !important;
            a {
              color: #f9f9f9 !important;
            }
          }
        }
      }
      .texts {
        padding-top: 40px;
        h1 {
          // width: 730px;
          height: 69px;
          font-size: 48px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 69px;
          margin-top: 80px;
          font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Regular";
        }
        p {
          // width: 582px;
          height: 71px;
          font-size: 20px;
          font-weight: 400;
          opacity: .8;
          color: #fff;
          line-height: 40px;
          margin-top: 10px;
          overflow: hidden;
          font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Semibold";
        }
        ul {
          margin-left: -40px;
          li {
            span {
              width: 100%;
              text-align: center;
              font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Semibold";
            }
          }
        }
      }
    }
  }
</style>